import {
  Box,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@agrotoken-tech/ui';
import { PERFORM_ACTION } from '@bcba/casl-authorization';
import { PageHeader } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';
import SentAccessRequestsTable from '../components/DigitalDossierAccessRequests/SentAccessRequests/SentAccessRequestsTable';
import { DigitalDossierSearch } from '../components/Explorer';
import { useUserContext } from '../contexts/UserContext';

export const DossierExplorerPage = () => {
  const { t } = useTranslation();
  const { explorerEnableSentAccessRequests } = useFlags();
  const { ability } = useUserContext();
  const shouldShowHistorySection =
    explorerEnableSentAccessRequests &&
    ability?.can(PERFORM_ACTION.List, 'DigitalDossierRequestedAccessRequest');

  return (
    <Flex direction={'column'} gridRowGap={5}>
      <PageHeader
        title={t('explorer.navigation.route.dossierExplorer')}
        description={t('explorer.digitalDossier.explorer.subTitle')}
      />
      <Tabs isLazy>
        <Box overflow={'auto'}>
          <TabList gap={8}>
            {shouldShowHistorySection ? (
              <Tab minWidth={'fit-content'} px={0}>
                {t('explorer.digitalDossier.explorer.history')}
              </Tab>
            ) : null}
            <Tab minWidth={'fit-content'} px={0}>
              {t('explorer.digitalDossier.explorer.newSearch')}
            </Tab>
          </TabList>
        </Box>
        <TabPanels py={6}>
          {shouldShowHistorySection ? (
            <TabPanel px={0}>
              <SentAccessRequestsTable />
            </TabPanel>
          ) : null}
          <TabPanel px={0}>
            <DigitalDossierSearch />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
